<template>
    <!--    最新资讯列表-组件-->
    <ul class="lastInfor">
        <li v-for="(item,index) in infordata"
            :key="index"
            @click="inforClick(index)"
        > 
        <!-- 添加气泡提示 -->
            <!-- <el-popover
                    placement="right-start"
                    width="200"
                    trigger="hover"
                    :content="item.title"
                    >
                <a href="#" slot="reference">{{item.title}}</a>
            </el-popover> -->

            <!-- 不添加气泡提示 -->
            <div>
                <span></span>
                <a href="javascript:void(0)">{{item.informName}}</a> 
            </div>
            
            <p class="defaultGrayTitle">{{item.createTime | translatDateToDayPointStr}}</p>
        </li>
    </ul>
</template>

<script>
    export default {
        name: "lp-InforList",
        props:['infordata'],//获取父级的传值
        methods:{
            inforClick(index){
                var item=this.infordata[index];
                //查看详情
                this.$router.push({path:"/detail/"+item.id,query:{type:2}})
            }
        }
    }
</script>

<style lang="less" >
    /*最新资讯-组件*/
    .lastInfor{
        // width: 570px;
        max-width: @contentWidth;//宽度最大1200px
        height: 296px;//默认高度，最多显示8条
        overflow: hidden;

        li{
            font-family: MicrosoftYaHei;
            height: 37px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            div{
                width: 100%;
                display: flex;
                align-items: center;
                overflow: hidden;
                a{
                    width: 100%;
                    /*单行-省略号*/
                    white-space: nowrap;
                    text-overflow:ellipsis;
                    overflow: hidden;
                    font-family: MicrosoftYaHeiUI;
                    font-size: 14px;
                    color: #333333;
                 }
                 a:hover{ 
                    color: @hoverDefaultColor;
                 }
                span{
                    display: block;
                    width: 6px;
                    height: 6px;
                    border-radius: 6px;
                    background: #79ABE0;
                    margin-right: 14px;
                }
            }
            p{
                font-family: MicrosoftYaHeiUI;
                font-size: 14px;
                color: #999999;
                text-align: right;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/inforlist/index.vue